import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api.service';

interface ApprovalState {
    workflowStatus: any | null;
    approvalHistory: any[];
    isLoading: boolean;
    error: string | null;
}

const initialState: ApprovalState = {
    workflowStatus: null,
    approvalHistory: [],
    isLoading: false,
    error: null,
};

export const fetchWorkflowStatus = createAsyncThunk(
    'approval/fetchWorkflowStatus',
    async (prId: number, { rejectWithValue }) => {
        try {
            const response = await apiService.getWorkflowStatus(prId);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
);

export const fetchApprovalHistory = createAsyncThunk(
    'approval/fetchHistory',
    async (prId: number, { rejectWithValue }) => {
        try {
            const response = await apiService.getApprovalHistory(prId);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
);

export const processApproval = createAsyncThunk(
    'approval/process',
    async (
        { prId, action, comments }: { prId: number; action: string; comments?: string },
        { rejectWithValue }
    ) => {
        try {
            const response = await apiService.processApproval(prId, action, comments);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
);

const approvalSlice = createSlice({
    name: 'approval',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchWorkflowStatus.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchWorkflowStatus.fulfilled, (state, action) => {
            state.isLoading = false;
            state.workflowStatus = action.payload;
        });
        builder.addCase(fetchWorkflowStatus.rejected, (state, action: any) => {
            state.isLoading = false;
            state.error = action.payload;
        });

        builder.addCase(fetchApprovalHistory.fulfilled, (state, action) => {
            state.approvalHistory = action.payload;
        });

        builder.addCase(processApproval.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(processApproval.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(processApproval.rejected, (state, action: any) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});

export const { clearError } = approvalSlice.actions;
export default approvalSlice.reducer;
